exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".warning[data-v-02b9d01f]{color:#f0ad4e}.success[data-v-02b9d01f]{color:#38c172}.fail[data-v-02b9d01f]{color:#e45551}.cancel[data-v-02b9d01f]{color:#f0ad4e}img[data-v-02b9d01f],ion-icon[data-v-02b9d01f]{display:inline-block}", ""]);

// exports
